import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import kankorService from './kankorService'
import axios from 'axios'
const api = '/api/'

export const ListKankorTerm = createAsyncThunk('kankor-term-list', async (params: {}, thunkAPI) => {
  try {
    return await kankorService.kankorTermList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createKankorTerm = createAsyncThunk(
  'kankor-term-create',
  async (data: {}, thunkAPI) => {
    try {
      return await kankorService.kankorTermCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editKankorTerm = createAsyncThunk('kankor-term-edit', async (id: string, thunkAPI) => {
  try {
    return await kankorService.kankorTermEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteKankorTerm = createAsyncThunk(
  'kankor-term-delete',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.kankorTermDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewKankorTerm = createAsyncThunk('kankor-term-view', async (id: string, thunkAPI) => {
  try {
    return await kankorService.kankorTermView(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const listKankorRoom = createAsyncThunk('kankor-room-list', async (id: string, thunkAPI) => {
  try {
    return await kankorService.kankorRoomList(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createKankorRoom = createAsyncThunk(
  'kankor-room-create',
  async (data: {}, thunkAPI) => {
    try {
      return await kankorService.kankorRoomCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editKankorRoom = createAsyncThunk('kankor-room-edit', async (id: string, thunkAPI) => {
  try {
    return await kankorService.kankorRoomEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteKankorRoom = createAsyncThunk(
  'kankor-room-delete',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.kankorRoomDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListKankorApplication = createAsyncThunk(
  'kankor-application-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}application/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListArchiveKankorApplication = createAsyncThunk(
  'kankor-application-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}application/archive-list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createKankorApplication = createAsyncThunk(
  'kankor-application-create',
  async (data: {}, thunkAPI) => {
    try {
      return await kankorService.kankorApplicationCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const UploadAppPhoto = createAsyncThunk('upload-photo', async (data: {}, thunkAPI) => {
  try {
    return await kankorService.uploadPhoto({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editKankorApplication = createAsyncThunk(
  'kankor-application-edit',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.kankorApplicationEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ViewKankorApplication = createAsyncThunk(
  'kankor-application-view',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.kankorApplicationView(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteKankorApplication = createAsyncThunk(
  'kankor-application-delete',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.kankorApplicationDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetTermAndProgram = createAsyncThunk('get-term-and-program', async (_, thunkAPI) => {
  try {
    return await kankorService.getTermAndProgram()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ApplicationStudents = createAsyncThunk(
  'app-students',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.applicationStudents(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SendStdToRoom = createAsyncThunk('send-std-to-room', async (data: {}, thunkAPI) => {
  try {
    return await kankorService.sendStdToRoom({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const KankorRoomStudents = createAsyncThunk(
  'room-students',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.roomStudents(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const RemoveStdFromRoom = createAsyncThunk(
  'remove-std-from-room',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.removeStdFromRoom(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintCard = createAsyncThunk(
  'print-card',
  async ({type, id}: {type: string; id: string}, thunkAPI) => {
    try {
      return await kankorService.printCard(type, id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const AppAttendance = createAsyncThunk('app-attendance', async (id: string, thunkAPI) => {
  try {
    return await kankorService.appAttendance(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAppScore = createAsyncThunk('get-app-score', async (id: string, thunkAPI) => {
  try {
    return await kankorService.getAppScore(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AppScoreStore = createAsyncThunk('app-score-create', async (data: {}, thunkAPI) => {
  try {
    return await kankorService.appScoreStore({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ApproveApplicationScore = createAsyncThunk(
  'approve-application-score',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.approveApplicationScore(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const BachelorAppExcelBook = createAsyncThunk(
  'bach-app-excel-book',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.bachelorAppExcelBook(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)
export const MasterAppExcelBook = createAsyncThunk(
  'master-app-excel-book',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.masterAppExcelBook(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetPrograms = createAsyncThunk('get-programs', async (id: string, thunkAPI) => {
  try {
    return await kankorService.getPrograms(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const listKankorApplicants = createAsyncThunk(
  'kankor-succeeded-application-list',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.getlistKankorApplicants(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getTermList = createAsyncThunk('get-term-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}application/get-term-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getTerms = createAsyncThunk('get-terms', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/get-terms/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getClass = createAsyncThunk('get-class-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}application/get-class-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getSemesters = createAsyncThunk('get-semesters-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}application/get-semesters-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createStudent = createAsyncThunk('student-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}application/student-create`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const changeKankorAppStatus = createAsyncThunk(
  'change-kankor-app-status',
  async ({id, type}: {type: string; id: string}, thunkAPI) => {
    try {
      await axios.get(`${api}application/change-kankor-app-status/${id}/${type}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetKankorRooms = createAsyncThunk('get-kankor-rooms', async (id: string, thunkAPI) => {
  try {
    return await kankorService.getKankorRooms(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const changeApplicationRoom = createAsyncThunk(
  'change-app-room',
  async (data: {}, thunkAPI) => {
    try {
      return await kankorService.changeAppRoom({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetTerms = createAsyncThunk('get-terms', async (_, thunkAPI) => {
  try {
    return await kankorService.getTerms()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const KankorTermReport = createAsyncThunk('term-report', async (id: string, thunkAPI) => {
  try {
    return await kankorService.termReport(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const TermReportPrint = createAsyncThunk(
  'term-report-print',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.termReportPrint(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const TermReportExcel = createAsyncThunk(
  'term-report-excel',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.termReportExcel(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const KankorSuccessTermReport = createAsyncThunk(
  'term-success-report',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.termSuccessReport(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const TermSuccessReportPrint = createAsyncThunk(
  'term-success-report-print',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.termSuccessReportPrint(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const TermSuccessReportExcel = createAsyncThunk(
  'term-success-report-excel',
  async (id: string, thunkAPI) => {
    try {
      return await kankorService.termSuccessReportExcel(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type KankorState = {
  errors: any
}

const initialState: KankorState = {
  errors: '',
}

export const kankorSlice = createSlice({
  name: 'kankor',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createKankorTerm.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = kankorSlice.actions
export default kankorSlice.reducer
